module.exports = {
	"account.user.driving.licence.already.exist": "Existuje iný účet s týmto číslom vodičského preuklazu.",
	"account.user.login.already.exist": "Tento e-mail sa už používa pri inom účte.",
	"account.user.suspended": "Túto akciu nie je možné vykonať, pretože používateľ je pozastavený",
	"action.add.payment": "Pridať platobnú metódu",
	"action.complete.my.account": "Vyplňte môj účet",
	"action.confirm.welcome.msg": "Poďme",
	"action.create.my.account": "Vytvoriť účet",
	"action.search.update.bookings": "Overiť dostupnosť",
	"action.update.payment": "Aktualizovať platobnú metódu",
	"anonymous.search.location.not.available": "The search is not available for this location",
	"booking.accept_usage_terms.link.label": "Terms of use",
	"booking.accept_usage_terms.text": "Kliknutím „Potvrdiť“ čestne vyhlasujete, že akceptujete zmluvné podmienky služby a v súčasnosti ste držiteľom platného vodičského preukazu v prípade, že využívate službu zdieľania vozidla. Viac v {link}.",
	"booking.accept_usage_terms.title": "Podmienky používania",
	"booking.action.cancel.forbidden": "Rezerváciu už nie je možné zrušiť",
	"booking.action.edit.forbidden": "Rezerváciu viac nie je možné upravovať",
	"booking.add.calendar": "Pridať do kalendára",
	"booking.confirm": "Potvrdiť rezerváciu",
	"booking.confirm_and_pay": "Potvrdiť a zaplatiť",
	"booking.deposit": "Bezpečnostný depozit",
	"booking.deposit.b": "Po potvrdení rezervácie vám bude zúčtovaná záloha vo výške {damageSafetyDeposit} {currency}\n Táto záloha môže byť použitá na krytie akýchkoľvek škôd spôsobených na vozidle počas vašej cesty. \n\n Ak bude vozidlo vrátené bez poškodenia alebo predĺženia, bude účtovaná {bookingPrice} {currency}",
	"booking.deposit.d": "Po potvrdení rezervácie bude vykonaný bankový vklad vo výške {bufferPrice} {currency}\n Zahŕňa to cenu rezervácie a poplatok za prípadné prekročenie. \n\n Bez prekročenia alebo poškodenia vozidla bude z vášho účtu zúčtovaná {bookingPrice} {currency}",
	"booking.deposit.db": "Po potvrdení rezervácie vám budú účtované dva bankové vklady:\n - Prvý vo výške {bufferPrice} {currency} vrátane ceny rezervácie a poplatku za prípadné prekročenie.\n - Druhý vo výške {damageSafetyDeposit} {currency} na pokrytie akýchkoľvek škôd spôsobených na vozidle počas rezervácie. \n\n Bez akéhokoľvek prekročenia alebo poškodenia vozidla bude účtovaná {bookingPrice} {currency}",
	"booking.deposit.info": "Za vašu rezerváciu bude zložená záloha",
	"booking.payment.prebilling.refused.error": "Platba bola zamietnutá, pretože debet na vašej kreditnej karte nie je dostatočný. Skúto znova s inou kartou. V prípade pretrvávania problémov sa obráťte na svoju banku.",
	"booking.payment.prebilling.technical.error": "Počas platby sa vyskytla chyba. Skúste neskôr znova.",
	"booking.success.sub.title": "Ďakujeme, že využívate naše služby!",
	"booking.success.title": "Gratulujeme, vaša rezervácia bola úspešne vytvorená!",
	"booking.type.label": "Typ rezervácie",
	"booking.type.one_way": "Jednosmerná",
	"booking.type.return_trip": "Jazda späť",
	"booking.update.period.expired": "Obdobie na aktualizáciu dátumov rezervácie vypršalo",
	"booking.usage.business": "Pracovne",
	"booking.usage.private": "Súkromne",
	"booking.view_payment_terms.title": "Platobné podmienky",
	"booking.voucher.different.code": "Váš promo kód nemôžete upraviť",
	"booking.voucher.placeholder": "I have a voucher code",
	"car.AUTOMATIC": "Automat",
	"car.DIESEL": "Diesel",
	"car.ELECTRIC": "Elektrické vozidlo",
	"car.FOLDING_SEATS": "Sklopné sedadlá",
	"car.GPS": "GPS",
	"car.HYBRID": "Hybrid",
	"car.LPG": "GPL",
	"car.MANUAL": "Manuál",
	"car.PETROL": "Benzín",
	"car.RADIO_CD": "Radio",
	"car.booking_details": "Informácie o rezervácii",
	"car.color": "Farba",
	"car.compact_cars": "Kompaktné vozidlá",
	"car.description": "Description",
	"car.details": "Informácie o vozidle",
	"car.doors": "Dvere",
	"car.filter.COMMERCIAL": "Komerčné vozidlá",
	"car.filter.PASSENGER": "Turizmus",
	"car.filter.accessories.air_conditioning": "Klimatizácia",
	"car.filter.accessories.baby_seat": "Baby seat",
	"car.filter.accessories.bluetooth": "Bluetooth",
	"car.filter.accessories.large_truck": "Veľké nákladné vozidlo",
	"car.filter.accessories.radio_cd": "Rádio",
	"car.filter.label_nb_persons": "Počet osôb",
	"car.filter.other": "Iné",
	"car.filter.other-nb": "Ostatné - {nb}",
	"car.filter.vehicle_type": "Typ vozidla",
	"car.filter_energy": "Energie",
	"car.filter_gearbox_type": "Typ prevodovky",
	"car.filter_persons": "osoby",
	"car.for_every_additional_km": "Na kilometre naviac",
	"car.km_included": "Zahrnuté km",
	"car.motorization": "Automobilizácia",
	"car.options": "Možnosti",
	"car.parking_additional_info": "Špecifické informácie o parkovaní",
	"car.places": "Sedadlá",
	"car.pricing": "Cena",
	"car.pricing.estimate": "Cenový odhad",
	"car.pricing.extra_km_cost_per_day": "Cena za km naviac",
	"car.pricing.free_km_per_day": "Km v rámci /24 h",
	"car.specifications": "Špecifikácia",
	"car.transmission": "Prevodovka",
	"car.utility_cars": "Úžitkové vozidlá",
	"car.version": "Verzia",
	"company.id.missing.booking.search": "ID spoločnosti je povinné pre anonymné vyhľadávanie rezervácií",
	"contact_page.phone_call_price": "(BEZPLATNÝ TELEFONÁT Z PEVNEJ LINKY)",
	"contact_page.title_1": "V prípade akýchkoľvek otázok týkajúcich sa prenájmu vozidla,",
	"contact_page.title_2": "neváhajte a kontaktujte nás prostredníctvom e-mailu.",
	"creditcard.data.insufficient.3ds": "Z dôvodu nových požiadaviek na 3DS2 vás žiadame o aktualizáciu platobných údajov.",
	"custom.field.type.boolean": "Áno/Nie",
	"data.with.colon": "{data}:",
	"document.issue.date": "Dátum vydania",
	"dropzone.inner.info": "Povolené súbory: JPEG, PNG, PDF",
	"dropzone.inner.title": "Nahrať dokument",
	"error.booking.member_invalid": "Váš účet ešte nebol overený.",
	"error.booking.no.usage": "Pre tieto dátumy rezervácie sa nepoužíva",
	"error.booking.no_credit_card": "Najprv zadajte informácie o kreditnej karte.",
	"error.booking.same_period": "Na toto obdobie už máte naplánovanú rezerváciu.",
	"error.change_password.400.bad_request": "Heslo je nesprávne",
	"error.contract.inactive": "Služba nie je aktívna pre vašu spoločnosť, obráťte sa na svojho servisného manažéra.",
	"error.contract.not-found": "Služba je pozastavená vašou spoločnosťou, obráťte sa na svojho servisného manažéra.",
	"error.credit.card.refused": "Kreditná karta bola zamietnutá",
	"error.forgot_password.404": "Skontrolujte svoj e-mail, nenašla sa žiadna zhoda s účtom",
	"error.form.email.already_exists": "Zadajte inú e-mailovú adresu",
	"error.form.email_invalid": "Zadajte platný e-mail",
	"error.form.inviteCode.notEmpty": "Zadajte kód pozvánky",
	"error.form.password.at_least": "Vaše heslo musí obsahovať aspoň 8 znakov",
	"error.form.password.at_most": "Vaše heslo musí obsahovať maximálne 25 znakov",
	"error.form.password.cannot_reset_same": "Vaše nové heslo sa musí odlišovať od aktuálneho hesla",
	"error.form.password.digit": "Vaše heslo musí obsahovať 1 číslo",
	"error.form.password.lower_letter": "Vaše heslo musí obsahovať 1 malé písmeno",
	"error.form.password.upper_letter": "Vaše heslo musí obsahovať 1 veľké písmeno",
	"error.form.password_confirmation.the_same": "Zadajte to isté heslo dvakrát",
	"error.form.password_old.the_same": "Nové heslo musí byť odlišné od predtým použitého hesla",
	"error.form.required": "Vyplňte všetky povinné polia",
	"error.form.suggestion.address.required": "Vyberte adresu zo zoznamu návrhov",
	"error.form.technical": "Technická chyba",
	"error.get.site.config": "Nepodarilo sa načítať konfiguráciu webu",
	"error.invite.code.invalid": "Komunita, ku ktorej by ste sa chceli pripojiť, neexistuje",
	"error.login.401.unauthorized": "Váš e-mail alebo heslo je nesprávne",
	"error.login.403.user.anonymized": "Váš účet sa momentálne anonymizuje, nemôžete ho viac používať",
	"error.login.422.user.not.enabled": "Váš účet nie je aktivovaný, skontrolujte svoj e-mail a pokračujte pokynmi na aktiváciu účtu.",
	"error.number.above.max": "Hodnota nemôže byť vyššia ako {value}",
	"error.number.below.min": "Hodnota nemôže byť nižšia ako {value}",
	"error.phone.format.invalid": "Tvar telefónneho čísla je nesprávny",
	"error.register.without.sso": "You can only subscribe using SSO",
	"error.request_error": "Chyba žiadosti",
	"error.reset_password.401": "Poskytnutý odkaz už nie je platný, požiadajte o nové heslo na stránke",
	"error.search.vehicles.403": "S aktuálnym aktívnym profilom nemôžete pristupovať k vybranému webu",
	"error.session.expired": "Platnosť relácie vypršala",
	"error.text.length.long": "Toto pole je obmedzené na {count} znakov",
	"error.text.length.short": "Toto pole vyžaduje najmenej {count} znakov",
	"error.user.verify.fail": "User verification failed",
	"error_profile_edit_member_approved": "Po overení účtu už nie je možné zmeniť meno a dátum narodenia",
	"faq.contactEmailFallback": "na náš kontaktný e-mail",
	"faq.contactPhoneFallback": "v spodnej časti stránky",
	"faq.other_question": "Nepodarilo sa vám nájsť odpoveď na otázku?",
	"file_upload_size_exceeded": "Súbor je príliš veľký. Maximal storlek: 5 MB",
	"footer.label.legal.information": "Právne informácie",
	"footer.label.personal.data": "Osobné údaje",
	"footer_callUs": "Zavolajte nám",
	"footer_other": "Ostatné",
	"footer_share": "Sledujte nás",
	"footer_society_about": "O nás",
	"footer_society_policy_privacy": "Ochrana súkromia",
	"footer_society_term": "Podmienky používania",
	"footer_writeUs": "Zadajte e-mail",
	"forgot_password.confirmation": "Odkaz na obnovenie hesla bol zaslaný na vašu e-mailovú adresu.",
	"forgot_password.description_line1": "Zadajte e-mail, ktorý používate vo svojom účte.",
	"forgot_password.description_line2": "Pošleme vám odkaz na obnovenie hesla.",
	"forgot_password.submit": "Pošlite mi resetovací odkaz",
	"generic.address": "Adresa",
	"generic.at": "o",
	"generic.book": "Rezervovať",
	"generic.cancel": "Zrušiť",
	"generic.canceled": "Zrušené",
	"generic.city": "Mesto",
	"generic.clear": "Vymazať",
	"generic.company": "Spoločnosť",
	"generic.completed": "Dokončené",
	"generic.country": "Krajina",
	"generic.email": "E-mail",
	"generic.end": "Koniec",
	"generic.expires.at": "platnosť",
	"generic.extend": "Predĺžiť",
	"generic.file": "Súbor",
	"generic.first.name": "Meno",
	"generic.last.name": "Priezvisko",
	"generic.location.fixture.label": "Stránky",
	"generic.location.history.label": "História",
	"generic.location.search.placeholder": "Vyhľadať adresu, mesto ...",
	"generic.mobile.phone": "Telefónne číslo",
	"generic.modify": "Upraviť",
	"generic.mr": "Pán",
	"generic.mrs": "Pani",
	"generic.next": "Ďalej",
	"generic.number": "Číslo",
	"generic.passport": "Pas",
	"generic.past.placeholder": "Tu nájdete svoje predchádzajúce rezervácie",
	"generic.phone.number": "Telefónne číslo",
	"generic.postal.code": "Poštové číslo",
	"generic.retry": "Skúste znova",
	"generic.save": "Uložiť",
	"generic.send": "Odoslať",
	"generic.start": "Štart",
	"generic.text": "Text",
	"generic.today": "Dnes",
	"generic.upcoming": "Budúce",
	"generic.updated": "Aktualizované",
	"generic.user": "Používateľ",
	"get.sso.config.fail": "This email address is not recognized for SSO login",
	"helpPage_carSharing_issue1_answer": "Ak sa chcete zaregistrovať, jednoducho prejdite na intranetový server vašej spoločnosti a vyhľadajte odkaz, ktorý vás prenesie na registračnú stránku (alebo pošlite žiadosť o predplatné na adresu {contactEmail}). Odkaz dostanete e-mailom.",
	"helpPage_carSharing_issue1_title": "Ako sa zaregistrovať?",
	"helpPage_carSharing_issue2_answer": "Heslo si môžete obnoviť na webovej stránke alebo v mobilných aplikáciách: v tomto prípade dostanete na registrovanú e-mailovú adresu odkaz na nastavenie nového hesla.",
	"helpPage_carSharing_issue2_title": "Čo keď stratím heslo?",
	"helpPage_carSharing_issue3_answer": "V prípade, že ste odznak stratili alebo máte nový, kontaktujte call-centrum na čísle {contactPhone} a odznak resetujte. Nový odznak nebude fungovať, kým nedôjde k resetu.",
	"helpPage_carSharing_issue3_title": "Čo ak som stratil svoj odznak alebo som dostal nový?",
	"helpPage_carSharing_issue4_answer": "ŠPZ vozidla je uvedené v potvrdzovacom e-maile a v potvrdzovacej SMS. Okrem toho nájdete vozidlo na rezervačnom portáli Moje rezervácie.",
	"helpPage_carSharing_issue4_title": "Ktoré vozidlo som si rezervoval?",
	"helpPage_carSharing_issue5_answer": "Uistite sa, že dátum a čas sú správne, tlačidlo Štart je k dispozícii iba od času rezervácie. V opačnom prípade môžete nasnímať odznak čítačkou kariet, aby sa otvorili dvere vozidla.",
	"helpPage_carSharing_issue5_title": "Prečo nemôžem nájsť tlačidlo Štart?",
	"helpPage_carSharing_issue6_answer": "Ak ste urobili rezerváciu a svetlo sa rozsvieti na zeleno, ale dvere sa neotvárajú, stlačte tlačidlo umiestnené na držadle dverí.",
	"helpPage_carSharing_issue6_title": "Prečo svieti zelené svetlo, ale dvere sú stále zatvorené?",
	"helpPage_carSharing_issue7_answer": "Po rezervácii vozidla môžete tiež upraviť alebo zrušiť rezerváciu z webovej stránky alebo mobilnej aplikácie. Ak potrebujete pomoc, obráťte sa na call centrum na čísle {contactPhone}.",
	"helpPage_carSharing_issue7_title": "Upraviť/zrušenie",
	"helpPage_carSharing_issue8_answer": "Odznak nemôžete nasnímať vopred, vozidlo môžete otvoriť iba vo vymedzenom čase.",
	"helpPage_carSharing_issue8_title": "Môžem odznak nasnímať vopred?",
	"helpPage_damages_issue1_answer": "Predtým, ako spustíte rezerváciu, uistite sa, že ste informovali o škodách v mobilnej aplikácii alebo telefonicky na linke call centra {contactPhone}.",
	"helpPage_damages_issue1_title": "Čo robiť v prípade poškodenia rezervovaného vozidla?",
	"helpPage_damages_issue2_answer": "Zachovajte pokoj a uistite sa, že sa nikto nezranil. Ste poistení. Ďalšie pokyny okamžite žiadajte na linke telefonického centra {contactPhone}.",
	"helpPage_damages_issue2_title": "Čo robiť v prípade nehody počas rezervácie?",
	"helpPage_subtitle": "V tejto časti nájdete odpovede na najčastejšie otázky.",
	"helpPage_tab_carSharing": "Služba",
	"helpPage_tab_damages": "Poškodenia",
	"helpPage_tab_vehicles": "Vozidlo",
	"helpPage_title": "Často kladené otázky (FAQ)",
	"helpPage_vehicles_issue1_answer": "Skontrolujte dátum a hodinu vašej rezervácie a potom skontrolujte, či sa ŠPZ zhoduje s vašou rezerváciou. Následne znova vykonajte overenie priložením IBA odznaku k čítačke. Uistite sa, že používate odznak, ktorý patrí tej istej osobe, ktorá vykonala rezerváciu, a že od poslednej rezervácie nedošlo k zmene. V prípade nedávnej zmeny odznaku sa obráťte na zákaznícky servis a požiadajte o okamžitú zmenu.",
	"helpPage_vehicles_issue1_title": "Prečo vozidlo nereaguje?",
	"helpPage_vehicles_issue2_answer": "Skontrolujte dátumy a hodiny vašej rezervácie a potom skontrolujte, či sa ŠPZ zhoduje s vašou rezerváciou. Uistite sa, že máte správny odznak (odznak osoby, ktorá vykonala rezerváciu).",
	"helpPage_vehicles_issue2_title": "Prečo čítačka kariet zobrazuje iba červené svetlo?",
	"helpPage_vehicles_issue3_answer": "Ak máte rezerváciu a svetlo je zelené, ale nepočujete odomykanie dverí, stlačením tlačidla na dverách vodiča odomknite dvere.",
	"helpPage_vehicles_issue3_title": "Prečo zostávajú dvere zatvorené?",
	"helpPage_vehicles_issue4_answer": "Skontrolujte štítok s evidenčným číslom vozidla, dátumy a časy a uistite sa, že máte funkčné pripojenie na internet.",
	"helpPage_vehicles_issue4_title": "Prečo nemôžem otvoriť dvere?",
	"helpPage_vehicles_issue5_answer": "Len sa uistite, že motor je vypnutý, dvere a batožinový priestor sú správne zatvorené a kľúče s malým čipom ste vložili do priečinka v odkladacej schránke.",
	"helpPage_vehicles_issue5_title": "Prečo nemôžem vozidlo uzamknúť?",
	"home.header_banner": "V októbri sa z <strong> Renault Mobility </strong> stane <strong> Mobilize share </strong>",
	"home.welcome": "Vitajte v {productName}",
	"home.welcome_solo": "Vitajte",
	"how_it_works.step_1": "<span class='bold'>Stiahnite si aplikáciu</span> z obchodu App Store alebo Google Play.",
	"how_it_works.step_2": "Otvorte aplikáciu a <span class='bold'>zaregistrujte sa</span> vyplnením formulára.",
	"how_it_works.step_3": "Odfotografujte svoj <span class='bold'>vodičský preukaz<span class='bold'>, <span class='bold'>občiansky preukaz</span> a </span>svoju tvár</span> s občianskym preukazom vedľa nej. Všetko v aplikácii uložte!",
	"how_it_works.step_4": "<span class='bold'>Zaregistrujte svoju bankovú kartu</span>, aby ste mohli realizovať platby za prenájom.",
	"how_it_works.step_5": "<span class='bold'>Overte svoju e-mailovú adresu<span class='bold'>kliknutím na odkaz, ktorý vám bol poslaný. </span>Skontrolujte si SPAM</span>.",
	"how_it_works.step_6": "Po overení vašej registrácie si<span class='bold'>zarezervujte vozidlo<span class='bold'> v našej aplikácii alebo na našej internetovej stránke. V deň rezervácie je </span>váš smartfón aj vaším kľúčom!</span>",
	"info.account.company.already.linked": "Táto spoločnosť je už prepojená s vašim účtom",
	"info.switch.profile": "<strong>New — </strong>You can now add and manage multiple profiles using the same credentials. This allows you to join corporate fleets of you company and use the same app to rent a vehicle for your week-ends.",
	"info.switching.profile": "Prepínanie profilu",
	"info.worldpay.return.success": "Priložené platobné informácie",
	"iso__BE": "Belgicko",
	"iso__CS": "Česká republika",
	"iso__DA": "Dánsko",
	"iso__DE": "Nemecko",
	"iso__ES": "Španielsko",
	"iso__FR": "Francúzsko",
	"iso__IT": "Taliansko",
	"iso__NL": "Holandsko",
	"iso__PL": "Poľsko",
	"iso__PT": "Portugalsko",
	"iso__SL": "Slovinsko",
	"iso__SV": "Švédsko",
	"iso__pt_BR": "Brazília",
	"label.accept_terms_and_conditions": "Súhlasím, aby ma spoločnosť Renault a jej sieť neskôr kontaktovala e-mailom za účelom vyšetrovania alebo informácií o nových produktoch a aktuálnych ponukách. Pri každom odoslaní budem mať možnosť ukončiť všetku komunikáciu.",
	"label.account.already.active": "Váš účet je aktívny",
	"label.account_activation_description": "Ak je váš účet overený, dostanete potvrdzovací e-mail a môžete naplno využívať našu službu.",
	"label.account_activation_title": "Účet bude aktivovaný najneskôr do 15 minút.",
	"label.activation.link.expired": "Aktivačný odkaz nie je platný",
	"label.activation.link.send": "Poslať znova",
	"label.activation.link.sent.success": "Aktivačný e-mail bude poslaný, ak používateľ existuje a účet nie je aktivovaný",
	"label.active.profile": "Aktívny profil",
	"label.actual.payment.method": "Aktuálna platobná metóda",
	"label.add.new.profile": "Pridať nový profil",
	"label.apply": "Použiť",
	"label.are_you_sure_you_want_to_cancel": "Chcete potvrdiť zrušenie?",
	"label.birth.day": "Dátum narodenia",
	"label.booking": "Rezervácia",
	"label.booking.past": "Minulé",
	"label.booking.past.placeholder": "Tu nájdete svoju históriu rezervácií.",
	"label.booking.today.part": "dnes o",
	"label.booking.upcoming.placeholder": "Tu nájdete svoje plánované a prebieha rezervácie",
	"label.cancel_my_booking": "Zrušiť moju rezerváciu",
	"label.car": "vozidlo",
	"label.carSharing": "Zdieľanie auta",
	"label.cars": "vozidlá",
	"label.civility": "Zdvorilostné oslovenie",
	"label.click_here": "Kliknite sem",
	"label.close": "Zatvoriť",
	"label.confirm_new_password": "Potvrdiť heslo",
	"label.congratulations": "Gratulujeme!",
	"label.continue": "Pokračovať",
	"label.creditCard_message": "Pre overenie vašej karty bude vytvorený dočasný debet. Debet s nízkou sumou {amountToTake} € sa môže dočasne zobraziť v účte spojenom s kartou. Ak debet pretrváva dlhšie než päť pracovných dní, obráťte sa na svoju banku.",
	"label.date": "Dátum",
	"label.delivery_place": "Vydávajúce mesto",
	"label.driving_licence": "Vodičský preukaz",
	"label.driving_licence_back": "Vodičský preukaz (zadná strana)",
	"label.driving_licence_front": "Vodičský preukaz (predná strana)",
	"label.edit.invite.code": "Upravte pozývací kód",
	"label.expiration_date": "Dátum platnosti",
	"label.file.upload.only.mobile": "Pre úpravu dokumentov použite mobilnú aplikáciu.",
	"label.filter_by": "Filtrovať podľa",
	"label.filters": "Filtre",
	"label.generic.error": "Vyskytla sa chyba. Skúste znova neskôr.",
	"label.hours": "hodiny",
	"label.how_it_works": "Ako to funguje?",
	"label.identity.card": "Občiansky preukaz",
	"label.identity.document.number": "Číslo dokladu totožnosti",
	"label.identity.document.type": "Typ dokladu totožnosti",
	"label.identity_card": "Doklad totožnosti",
	"label.identity_card_back": "Doklad totožnosti (zadná strana)",
	"label.identity_card_front": "Doklad totožnosti (predná strana)",
	"label.identity_card_selfie": "Fotografia tváre s vaším dokladom totožnosti",
	"label.invite_code_placeholder": "Zadajte svoj kód pozvánky",
	"label.italy.fiscal.code": "Zadanie fiškálneho čísla",
	"label.italy.resident": "Ste Talian?",
	"label.licence_number": "Číslo vodičského preukazu",
	"label.load_more": "Viac výsledkov",
	"label.login": "Prihlásiť sa",
	"label.logout": "Odhlásiť sa",
	"label.manager.email": "E-mail nadriadeného",
	"label.mandatory_fields": "* Povinné polia",
	"label.member_already": "Už ste členom?",
	"label.my_account": "Môj účet",
	"label.my_reservations": "Moje rezervácie",
	"label.new.password": "Nové heslo",
	"label.no_account": "Nový člen?",
	"label.or_by_phone": "alebo telefónnym číslom",
	"label.password": "Heslo",
	"label.password_forgot": "Zabudnuté heslo",
	"label.phone": "Telefónne číslo",
	"label.phone.suffix": "Prípona telefónneho čísla",
	"label.plateNumber": "Číslo tabuľky",
	"label.price": "cena",
	"label.redirectMobileApp": "Pre začatie rezervácie si stiahnite našu mobilnú aplikáciu!",
	"label.remember_me": "Zostať prihlásení",
	"label.reset_password_done": "Vaše heslo bolo aktualizované",
	"label.return": "Späť",
	"label.schedule": "Hodiny",
	"label.search": "Vyhľadať",
	"label.selected.language": "Zvolený jazyk",
	"label.subject": "Predmet",
	"label.switch.profile": "Prepnúť profil",
	"label.the": "do",
	"label.validate": "Overiť",
	"label.vehicles_found": "{count} nájdených výsledkov",
	"label.warning": "Upozornenie",
	"label.welcome.finish.registration": "Ak chcete potvrdiť svoj termín, dokončite registráciu.",
	"label.you_are_trying_to_cancel_your_booking": "Chystáte sa zrušiť svoju rezerváciu!",
	"label.your.active.profile": "Váš aktívny profil",
	"label.your.other.profiles": "Vaše ďalšie profily",
	"label.your_message": "Vaša správa",
	"language.header": "Vyberte svoj jazyk",
	"login.forgot_password": "Zabudli ste heslo?",
	"login.register": "Registrácia",
	"menu.faq": "Informácie",
	"mobile_banner.text": "Stiahnite si aplikáciu {productName}",
	"page.password.update.sub.title": "Z bezpečnostných dôvodov vás žiadame o aktualizáciu hesla",
	"page.password.update.title": "Aktualizácia hesla",
	"parking.special_opening_legend": "Mimoriadne otváracie hodiny",
	"part.company.fill.extra.info": "požaduje od vás, aby ste vyplnili dodatočné informácie.",
	"part.complete.register.for": "Dokončite svoju registráciu na",
	"part.create.account.for": "Vytvoriť účet pre",
	"part.link.account.to": "Prepojte svoj účet s",
	"part.your.email": "tvoj email",
	"placeholder.enter.number": "Zadajte číslo ...",
	"placeholder.enter.text": "Píšte sem ...",
	"placeholder.search": "Hľadať ...",
	"profile.422.error.info": "Zdá sa, že vo vašom profile chýbajú niektoré informácie.\n Spoločne overíme váš profil, aby sme sa ubezpečili, že je všetko v poriadku.",
	"profile.info.new.email": "Pri aktualizácii e-mailovej adresy dostanete e-mail pre overenie e-mailovej adresy. Bez overenia nebudete mať možnosť vytvárať rezerváciu.",
	"profile.label.before.arrival": "Pred príchodom",
	"profile.label.before.departure": "Pred odchodom",
	"profile.label.charges.call.center": "Za zmeny vykonané call centrom",
	"profile.label.charges.my": "Za zmeny, ktoré som vykonal",
	"profile.label.current.password": "Aktuálne heslo",
	"profile.label.expiration.date.status": "Môj vodičský preukaz nemá dátum spotreby",
	"profile.label.min.15": "15 minút",
	"profile.label.min.30": "30 minút",
	"profile.label.min.45": "45 minút",
	"profile.label.new.email": "Nová e-mailová adresa",
	"profile.label.street.field": "Adresa (číslo + názov ulice)",
	"profile.label.validated.email": "Overená e-mailová adresa",
	"profile.section.additional.info": "Ďalšie informácie",
	"profile.section.credentials": "Prihlasovacie údaje",
	"profile.section.language": "Jazyk profilu",
	"profile.section.notifications": "Oznámenia a upozornenia",
	"profile.section.payment.info": "Platobné údaje",
	"profile.section.personal.info": "Osobné informácie",
	"profile.section.selfie": "Selfie",
	"profile.section.technician.access": "Prístup technika",
	"profile.select.menu.item": "Vyberte položku menu na ľavej strane",
	"profile.selfie.section.info": "Odfotografujte si tvár spolu s občianskym preukazom vedľa tváre.",
	"profile.suspended": "Váš profil je pozastavený",
	"profile.title.email.notifications": "E-mailové upozornenia",
	"profile.title.language.select": "Jazyk používaný pre oznámenia a e-maily",
	"profile.title.sms.notifications": "SMS upozornenia",
	"profile.title.update.email": "Aktualizovať e-mailovú adresu",
	"profile.title.update.password": "Aktualizovať heslo",
	"profile_error_driver_license_invalid": "Vodičský preukaz nie je platný",
	"register.field.info.password": "Musí obsahovať aspoň 1 číslo, 1 veľké písmeno, 1 malé písmeno a musí mať od 8 do 25 znakov",
	"register.info.payment.saved": "Platobná metóda je uložená.",
	"register.info.profile.creation.forbidden": "You can't link your profile to this company",
	"register.success.info": "Na {email} bol odoslaný aktivačný odkaz. Skontrolujte si svoju schánku a spam a podľa pokynov aktivujte svoj účet predtým, než vyprší platnosť odkazu.",
	"register.terms.ads": "I consent to the processing of my data for marketing purposes (with both automated and traditional methods) in relation to mobility products and / or services",
	"register.terms.prefix.accept": "Akceptujem",
	"register.terms.privacy.link.label": "Privacy policy",
	"register.terms.privacy.text": "I accept the {link} of {company}",
	"register.terms.root.privacy": "ochrana súkromia",
	"register.terms.root.tos": "podmienky odberu",
	"register.terms.root.tou": "podmienky používania",
	"register.terms.suffix.ads": "použite informácie o mne pre komerčné účely",
	"register.terms.suffix.of": "z",
	"register.terms.usage.link.label": "Terms of use",
	"register.terms.usage.subscription.link.label": "Terms of subscription",
	"register.terms.usage.subscription.text": "I accept the {link} of {company}",
	"register.terms.usage.text": "I accept the {link} of {company}",
	"register.title.account.created": "Blahoželáme {firstName}, váš účet bol vytvorený",
	"register.title.account.linked": "Gratulujeme {firstName}, nový profil bol prepojený s vaším účtom",
	"register.title.account.updated": "Gratulujeme {firstName}, váš účet bol aktualizovaný",
	"reset_password.title": "Obnovenie hesla",
	"search.filter_alphabetically": "Abecedne",
	"search.filter_by": "Triediť podľa",
	"search.filter_by_price": "Podľa ceny",
	"search.result.empty": "Žiadne výsledky",
	"service.corporate.intro": "Chcete sa stať súčasťou komunity? Zadajte svoj kód pozvánky.",
	"service.intro_label": "Akú službu {productName} chcete odoberať?",
	"service.private.intro": "Chcete si rezervovať vozidlo zo siete {productName}?",
	"service.private.renaultfr": "Pre odoberanie {productName} si stiahnite aplikáciu vo svojom obchode v telefóne.",
	"service.private.select_country": "Vyberte krajinu",
	"service.usage.corporate": "Firemné zdieľanie vozidiel",
	"service.usage.private": "Prenájom vozidiel 24/7",
	"service.usage.vr": "Náhradné vozidlo",
	"service.vr.intro": "Ďakujeme za váš záujem o našu službu!\n\nAk sa chcete stať členom, kontaktujte svojho predajcu a požiadajte o odkaz na registráciu.",
	"sncf.home.login.msg": "Are you an SNCF employee? Log in.",
	"sso.login.description": "Zadajte svoju pracovnú e -mailovú adresu",
	"sso.login.title": "Spojenie so SSO",
	"status.APPROVED": "Profil overený",
	"status.NOT_APPROVED": "Váš profil je odmietnutý. Aktualizujte svoj profil.",
	"status.TO_COMPLETE": "Neúplné",
	"status.TO_REVIEW": "Váš profil čaká na overenie",
	"tagline": "Samoobslužný prenájom vozidiel 24/7",
	"title.add.payment.later": "Môžete ho pridať neskôr.",
	"title.add.payment.method": "Pridajte platobnú metódu.",
	"title.bookings.welcome.tutorial": "Nájdete tu svoju rezerváciu, ktorá je už naplánovaná",
	"title.modify.booking": "Upraviť moju rezerváciu",
	"title.password.change.success": "Vaše nové heslo bolo uložené",
	"title.update.booking": "Aktualizácia rezervácie",
	"title.welcome.to.brand": "Dobrý deň {firstName}, víta vás {brandName}.",
	"title.welcome.to.program": "Dobrý deň, {firstName}, vitajte v {brandName} {program}.",
	"vehicle.incorrect.usage": "Pre tento typ použitia nie je vozidlo k dispozícii",
	"week.day.friday": "Piatok",
	"week.day.monday": "Pondelok",
	"week.day.saturday": "Sobota",
	"week.day.sunday": "Nedeľa",
	"week.day.thursday": "Štvrtok",
	"week.day.tuesday": "Utorok",
	"week.day.wednesday": "Streda"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/i18n/sk.json
 ** module id = 429
 ** module chunks = 0
 **/